import Default from "./RichCopyToClipboardButton";
export * from "./RichCopyToClipboardButton";

export default Default;